import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MessengerService } from '@services/messenger/messenger.service';
import { StorageService } from '@services/storage/storage.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FrontendServices } from '@ibexfusion/core-utils';
import { Models } from '@ibexfusion/models';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent {

  email: string;
  password = '';
  rememberCredentials = false;
  activeView = 'default';
  loginFailed = false;

  constructor(private router: Router, private ms: MessengerService, private storage: StorageService, private http: HttpClient) {
  }

  async login() {
    this.loginFailed = false;
    const timestampData = new FormData();
    timestampData.append('timestamp', FrontendServices.EncryptionService.encryptAesString(Date.now() + '|' + Date.now()));
    const headers = new HttpHeaders({ 'Content-Type': 'multipart/form-data' });
    const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!emailRegex.test(this.email.toLowerCase())) {
      const ibex3Result = (await this.http.post('https://ibex3.ibexfusion.com/existingusers4ng.php', timestampData, <any>headers).toPromise()) as any;
      if (ibex3Result.find(el => el === this.email)) {
        const data = [{ name: 'username', value: this.email, encrypted: true }, { name: 'password', value: this.password, encrypted: true }];
        return this.post(data as any, 'https://ibex3.ibexfusion.com/ngauth.php', 'POST', 'self');
      }
      const ibex2Result = (await this.http.post('https://ibex2reloaded.ibexfusion.com/ibex/existingusers4ng.php', timestampData, <any>headers).toPromise()) as any;
      if (ibex2Result.find(el => el === this.email)) {
        const data = [{ name: 'username', value: this.email, encrypted: true }, { name: 'password', value: this.password, encrypted: true }];
        return this.post(data as any, 'https://ibex2reloaded.ibexfusion.com/ibex/ngauth.php', 'POST', 'self');
      }
    }
    try {
      const result = await this.ms.loginWithEmailPasswordCredential(this.email, this.password);
      if (result?.level && this.rememberCredentials && !await this.storage.get('rememberToken')) {
        this.ms.createDeviceIdTokenCredential();
      }
    } catch (err) {
      console.log(err);
      this.loginFailed = true;
    }
  }

  async forgotPassword() {
    await this.ms.createResetCredentials(this.email);
    this.router.navigateByUrl('(auth:auth/(authentication:message))?messagetype=setToken', { replaceUrl: true });
  }

  private post(parameters: Models.LoginParameter[], url, type, target) {
    const mapForm = document.createElement('form');
    Object.assign(mapForm, { target: '_' + target, method: type, action: url });
    for (const param of parameters.filter(p => !!p.name && !!p.value)) {
      mapForm.appendChild(Object.assign(document.createElement('input'), {
        type: 'hidden', name: param.name, value: param.encrypted ? FrontendServices.EncryptionService.encryptAesString(`${param.value}|${Date.now()}`) : param.value
      }));
    }
    document.body.appendChild(mapForm);
    mapForm.submit();
    document.body.removeChild(mapForm);
  }

}
